import { useState, useEffect } from "react";
import { getTreeDataV2Api } from "../api/registry.api";
import { headersBuilder } from "../libs/helpers/callApi";

// Simple in-memory cache
const cache = {
  data: null,
};

const useSectorData = () => {
  const [data, setData] = useState(cache.data || []);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (cache.data) {
      setData(cache.data);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const headers = headersBuilder();
        const response = await getTreeDataV2Api({ headers, entity: "Sector" });
        const treeData = response || [];
        cache.data = treeData;
        setData(treeData);
      } catch (err) {
        console.error("Error loading sector data:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { data, loading, error };
};

export default useSectorData;
